<template>
  <div class="home-view">
    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        background: linear-gradient(to bottom, #99cfe9, #afd5e8);
      "
    />
    <!-- <span
      style="position: absolute; top: 0; z-index: 99999999; font-size: 12rem"
      >{{ aaa }}</span
    > -->
    <page-header
      :is-menu="isLoadingComplete"
      @list-change="listChange"
    ></page-header>
    <loading-page
      v-if="!isLoadingComplete"
      @complete="loadingComplete"
    ></loading-page>
    <template v-else>
      <img
        v-if="currentIndex == 0"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        src="~@/assets/images/home-bg.png"
      />
      <img
        v-else-if="currentIndex == 1 || currentIndex == 2"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        src="~@/assets/images/intro-bg.png"
      />
      <img
        v-else-if="currentIndex == 3"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        src="~@/assets/images/about-bg.png"
      />
      <img
        v-else-if="currentIndex == 4"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        src="~@/assets/images/work-bg.png"
      />

      <swiper
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        @slideNextTransitionStart="onSlideNextTransitionStart"
        direction="vertical"
        style="height: 100%; width: 100%; position: absolute; top: 0; left: 0"
        :longSwipesRatio="0.1"
        :resistanceRatio="0.1"
      >
        <swiper-slide>
          <homePage ref="homePageRef" v-if="currentIndex == 0"></homePage>
        </swiper-slide>
        <swiper-slide>
          <introductionPage></introductionPage>
        </swiper-slide>
        <swiper-slide>
          <!-- v-if="currentIndex == 2" -->
          <gamePage :key="currentKey" @slideTo="gameSlideChange"></gamePage>
        </swiper-slide>
        <swiper-slide>
          <!-- v-if="currentIndex == 3" -->
          <aboutPage
            :key="currentKey"
            :index="aboutIndex"
            @indexChange="indexChange"
          ></aboutPage>
        </swiper-slide>
        <swiper-slide>
          <workPage></workPage>
        </swiper-slide>
      </swiper>
      <page-bottom
        v-if="isLoadingComplete && currentIndex != 4 && currentIndex != 3"
      ></page-bottom>
    </template>
    <horizontal></horizontal>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import loadingPage from "./page/loadingPage.vue";
import homePage from "./page/homePage.vue";
import introductionPage from "./page/introductionPage.vue";
import gamePage from "./page/gamePage.vue";
import workPage from "./page/workPage.vue";
import aboutPage from "./page/about/index.vue";
import horizontal from "./horizontal.vue";
import pageHeader from "./pageHeader.vue";
import pageBottom from "./pageBottom.vue";

import { loadLoadingPage } from "@/assets/js/preload";
loadLoadingPage();

const aaa = ref(0);
onMounted(() => {
  //Safari的 vh包括操作栏
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  window.addEventListener("resize", () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    aaa.value = new Date().getTime();
  });
});

const isLoadingComplete = ref(false);
const loadingComplete = () => {
  isLoadingComplete.value = true;
};

const swiperRef = ref({});
const onSwiper = (swiper) => {
  console.log(swiper);
  swiperRef.value = swiper;
};
const listChange = (e) => {
  if (e == currentIndex.value) return;
  swiperRef.value.slideTo(e, 360);
};

const currentKey = ref(0);
const currentIndex = ref(0);
const onSlideChange = (e) => {
  currentIndex.value = e.realIndex;
  if(e.realIndex == 2 || e.realIndex == 3){
    currentKey.value = new Date().getTime();
  }
};

const homePageRef = ref();
const onSlideNextTransitionStart = (e) => {
  if (e.realIndex == 1) {
    console.log(e.realIndex, 123123);
    homePageRef.value.endHandle();
  }
};

const aboutIndex = ref(0);
const indexChange = (e) => {
  aboutIndex.value = e;
};

const gameSlideChange = (key) => {
  if (key == "prev") {
    listChange(1);
  } else if (key == "next") {
    listChange(3);
  }
};
</script>

<style lang="scss" scoped>
.home-view {
  width: 100%;
  // height: 100vh;
  height: calc(var(--vh) * 100);
  position: relative;
  overflow: hidden;
}
</style>